/* Hive & Harvest | hh-brand.js
   Matches a pad's background to the backdrop colour of its photo, so the photo
   runs into the pad with no visible join. Any element with data-hh-sample="<small image url>"
   gets --s-flat (bottom edge), and --s-top / --s-bot (the edge that meets the text).
   Safe to load more than once. Built 31 Oct 2026. */
(function () {
  function avg(d, w, x0, x1, y0, y1) {
    var r = 0, g = 0, b = 0, n = 0;
    for (var y = y0; y < y1; y++) {
      for (var x = x0; x < x1; x++) {
        var i = (y * w + x) * 4;
        r += d[i]; g += d[i + 1]; b += d[i + 2]; n++;
      }
    }
    return n ? 'rgb(' + Math.round(r / n) + ',' + Math.round(g / n) + ',' + Math.round(b / n) + ')' : null;
  }
  function mix(a, b) {
    var pa = a.match(/\d+/g).map(Number), pb = b.match(/\d+/g).map(Number);
    return 'rgb(' + Math.round((pa[0] + pb[0]) / 2) + ',' + Math.round((pa[1] + pb[1]) / 2) + ',' + Math.round((pa[2] + pb[2]) / 2) + ')';
  }
  function sample(el) {
    if (el.getAttribute('data-hh-done')) return;
    el.setAttribute('data-hh-done', '1');
    var src = el.getAttribute('data-hh-sample');
    if (!src) return;
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () {
      try {
        var w = im.naturalWidth, h = im.naturalHeight;
        var c = document.createElement('canvas'); c.width = w; c.height = h;
        var ctx = c.getContext('2d'); ctx.drawImage(im, 0, 0);
        var d = ctx.getImageData(0, 0, w, h).data;
        var strip = Math.max(2, Math.round(h * 0.04));
        var edge = Math.max(2, Math.round(w * 0.05));
        var side = Math.round(w * 0.22);
        var bl = avg(d, w, 0, side, h - strip, h);
        var br = avg(d, w, w - side, w, h - strip, h);
        el.style.setProperty('--s-flat', bl === br ? bl : mix(bl, br));
        var flip = el.classList.contains('is-flip');
        var x0 = flip ? 0 : w - edge, x1 = flip ? edge : w;
        el.style.setProperty('--s-top', avg(d, w, x0, x1, 0, Math.round(h * 0.12)));
        el.style.setProperty('--s-bot', avg(d, w, x0, x1, h - Math.round(h * 0.12), h));
      } catch (e) { /* keep the fallback colour */ }
    };
    im.src = src.indexOf('//') === 0 ? location.protocol + src : src;
  }
  function run() { document.querySelectorAll('[data-hh-sample]').forEach(sample); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', run); } else { run(); }
  /* Re-run when sections are edited in the theme editor */
  document.addEventListener('shopify:section:load', run);
})();
